export const amlScreeningBasePath = (profileId) => `/customers/${profileId}/aml-screening`;
